import type { ExtractKeysWithDotNotation } from "@tellescope/ui";
import { useTypedSearchParams } from "../../../hooks/use-typed-search-params";

export interface InboxThreadQueryParams {
  draftId?: string;
}

const VALID_INBOX_THREAD_QUERY_PARAM_KEYS = [
  "draftId",
] as const satisfies ExtractKeysWithDotNotation<InboxThreadQueryParams>[];

const INBOX_THREAD_ARRAY_KEYS = [] as const satisfies ExtractKeysWithDotNotation<InboxThreadQueryParams>[];

export const useInboxThreadSearchParams = () => {
  return useTypedSearchParams<InboxThreadQueryParams>(VALID_INBOX_THREAD_QUERY_PARAM_KEYS, INBOX_THREAD_ARRAY_KEYS);
};
